module.exports = __webpack_public_path__ + "static/img/a074.9df7361.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a074.jpg
// module id = vhjW
// module chunks = 0